export enum NewsletterQueryParams {
  EmailList = 'emailList',
}

export enum NotificationQueryParams {
  SmsUpdate = 'smsUpdate',
}
